import { View } from 'foundations-components/components/View';

/**
 * Wraps the content in a view with a max inline size of 1280px and a margin of auto.
 * This allows all of our content to be equally centered.
 *
 * @param children - The children to wrap.
 * @returns The wrapped content.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentWrapper = ({
  children,
  isUngatedForUnifiedAcademyNavigation = false
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginInline: 'auto',
    maxInlineSize: isUngatedForUnifiedAcademyNavigation ? '1280px' : '900px',
    children: children
  });
};